class CartPage {
  constructor() {
    this.container = document.getElementById('cart-page');
    this.isUpdating = false;
    this.updateQueue = [];

    if (!this.container) return;

    this.init();
  }

  init() {
    // Handle quantity changes
    this.container.addEventListener('click', (e) => {
      const target = e.target.closest('[data-quantity-increase], [data-quantity-decrease], [data-cart-item-remove]');

      if (target?.hasAttribute('data-quantity-increase')) {
        e.preventDefault();
        this.updateQuantity(target, 1);
      } else if (target?.hasAttribute('data-quantity-decrease')) {
        e.preventDefault();
        this.updateQuantity(target, -1);
      } else if (target?.hasAttribute('data-cart-item-remove')) {
        e.preventDefault();
        this.removeItem(target);
      }
    });

    // Handle manual quantity input
    this.container.addEventListener('change', (e) => {
      if (e.target.hasAttribute('data-quantity-input')) {
        this.updateQuantityDirect(e.target);
      }
    });

    // Listen for cart updates
    document.addEventListener('cart:update', () => {
      this.refresh();
    });
  }

  async updateQuantity(button, change) {
    if (this.isUpdating) return;

    const key = button.getAttribute('data-key');
    const input = this.container.querySelector(`input[data-key="${key}"]`);
    const currentQty = parseInt(input.value) || 0;
    const newQty = Math.max(0, currentQty + change);

    // Update UI optimistically
    input.value = newQty;
    this.setLoadingState(key, true);

    await this.updateCart(key, newQty);
  }

  async updateQuantityDirect(input) {
    if (this.isUpdating) return;

    const key = input.getAttribute('data-key');
    let newQty = parseInt(input.value) || 0;

    if (newQty < 0) {
      newQty = 0;
      input.value = 0;
    }

    this.setLoadingState(key, true);
    await this.updateCart(key, newQty);
  }

  async removeItem(button) {
    if (this.isUpdating) return;

    const key = button.getAttribute('data-key');
    const cartItem = button.closest('.cart-item');

    // Add visual feedback
    if (cartItem) {
      cartItem.style.opacity = '0.5';
      cartItem.style.pointerEvents = 'none';
    }

    await this.updateCart(key, 0);
  }

  setLoadingState(key, isLoading) {
    const buttons = this.container.querySelectorAll(`[data-key="${key}"]`);
    buttons.forEach(button => {
      if (button.tagName === 'BUTTON') {
        button.disabled = isLoading;
      } else if (button.tagName === 'INPUT') {
        button.disabled = isLoading;
      }
    });
  }

  async updateCart(key, quantity) {
    // Add to queue if already updating
    if (this.isUpdating) {
      this.updateQueue.push({ key, quantity });
      return;
    }

    this.isUpdating = true;

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      });

      if (response.ok) {
        const cart = await response.json();
        await this.refreshFromCartData(cart);
      } else {
        console.error('Error updating cart');
        // Refresh to restore correct state
        await this.refresh();
      }
    } catch (error) {
      console.error('Error updating cart:', error);
      // Refresh to restore correct state
      await this.refresh();
    } finally {
      this.setLoadingState(key, false);
      this.isUpdating = false;

      // Process queue
      if (this.updateQueue.length > 0) {
        const nextUpdate = this.updateQueue.shift();
        await this.updateCart(nextUpdate.key, nextUpdate.quantity);
      }
    }
  }

  async refreshFromCartData(cart) {
    try {
      // Reload the page to get fresh cart HTML
      // This is the simplest approach for the cart page
      window.location.reload();
    } catch (error) {
      console.error('Error refreshing cart from data:', error);
    }
  }

  async refresh() {
    try {
      // Reload the page to get fresh cart
      window.location.reload();
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
  }
}

// Initialize cart page when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CartPage());
} else {
  new CartPage();
}
